import { AuthPromoPlanContent } from './AuthPromoSection.types'

export const authPromoPlanContent: AuthPromoPlanContent = {
  default: [
    '7-day trial of premium features',
    'No credit card required',
    'Free forever for core features'
  ],
  pro: ['Set up your account in minutes', 'Unlimited scans', 'Code customization'],
  proplus: [
    'Set up your account in minutes',
    'Collaborate with your team',
    'Artist-designed codes'
  ],
  growth: ['Set up your account in minutes', 'Geo-location tracking', 'White label customization'],
  accept_invite: [
    'Set up your account in minutes',
    'Collaborate with your team',
    'White label customization'
  ]
}
